import ajax from './ajax'
// const BASE_URL = '/gw'
const BASE_URL = 'https://web-api.25you.cn'
// const BASE_URL = 'http://web-api-src.25you.cn'
export const reqData = (service, data, isToken = false) => ajax(BASE_URL + service, data, isToken);



// WEBPACK FOOTER //
// ./src/api/index.js